export interface List {
	label: string;
	value: string;
}

export const day: Array<List> = [
	{ label: 'Senin', value: 'monday' },
	{ label: 'Selasa', value: 'tuesday' },
	{ label: 'Rabu', value: 'wednesday' },
	{ label: 'Kamis', value: 'thursday' },
	{ label: 'Jumat', value: 'friday' },
	{ label: 'Sabtu', value: 'saturday' },
	{ label: 'Minggu', value: 'sunday' },
];

export const level: Array<List> = [
	{ label: 'Technical Support', value: 'tech' },
	{ label: 'Inventory Control', value: 'ic' },
];

export const status: Array<List> = [
	{ label: 'Semua', value: 'all' },
	{ label: 'Aktif', value: 'active' },
	{ label: 'Tidak Aktif', value: 'inactive' },
];

export const outletcrew = [
	{
		crew_id: 45,
		crew_name: 'admin',
		id_scheduler: 159,
		outlet_id: 440,
		outlet_name: 'Yummykitchen Sunter (YK20)',
		schedule_name: 'Inventory/STO/Yummykitchen Sunter (YK20)/13-09-2021',
		lines: [
			{
				count_product_brand: 20,
				product_brand_id: 'Malamoo',
				products: [
					{
						count_product: 13,
						links: {
							next_page: '/pagination/159/Malamoo/Semi Finished Goods/2',
						},
						product: [
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00050540',
								product_id: 14672,
								product_name: 'Beef, Malamoo, Pax',
								product_uom: 'Pax',
								soh: 66.0,
							},
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00056228',
								product_id: 15178,
								product_name: 'Bumbu Extra Mala, Malamoo, Pax',
								product_uom: 'Pax',
								soh: 48.0,
							},
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00058984',
								product_id: 15413,
								product_name: 'Bumbu Garlic, Malamoo, gr',
								product_uom: 'Gr',
								soh: -12.0,
							},
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00050541',
								product_id: 14673,
								product_name: 'Bumbu Ori, Malamoo, Pax',
								product_uom: 'Pax',
								soh: 145.0,
							},
						],
						product_category: 'Semi Finished Goods',
					},
					{
						count_product: 2,
						product: [
							{
								category_complete_name:
									'Capitalize / Food Material / Brand Partner',
								product_code: 'BPFM00064967',
								product_id: 27640,
								product_name: 'Bumbu Honey, Malamoo, gr',
								product_uom: 'Gr',
								soh: 0.0,
							},
							{
								category_complete_name:
									'Capitalize / Food Material / Brand Partner',
								product_code: 'BPFM00064966',
								product_id: 27639,
								product_name: 'Bumbu Korea, Malamoo, gr',
								product_uom: 'Gr',
								soh: 0.0,
							},
						],
						product_category: 'Food Material',
					},
					{
						count_product: 5,
						links: {
							next_page: '/pagination/159/Malamoo/Packaging Material/2',
						},
						product: [
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00050553',
								product_id: 13533,
								product_name: 'Cup 100 ml, Malamoo, 25 Pcs',
								product_uom: 'Pack 25pcs',
								soh: 3.72,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00050554',
								product_id: 13534,
								product_name: 'Cup 60 ml, Malamoo, 100 Pcs',
								product_uom: 'Pack 100pcs',
								soh: 1.05,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00050552',
								product_id: 13532,
								product_name: 'Paper Box, Malamoo, 25 Pcs',
								product_uom: 'Pack 25pcs',
								soh: 5.88,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00050550',
								product_id: 13531,
								product_name: 'Plastik Alas, Malamoo, 120 Pcs',
								product_uom: 'Pack 120pcs',
								soh: 1.327,
							},
						],
						product_category: 'Packaging Material',
					},
				],
			},
			{
				count_product_brand: 4,
				product_brand_id: 'Acaii Tea',
				products: [
					{
						count_product: 4,
						product: [
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00053438',
								product_id: 13589,
								product_name: 'Box Besar, Acaii Tea, Pcs',
								product_uom: 'Pcs',
								soh: 0.0,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00053439',
								product_id: 13590,
								product_name: 'Box Kecil, Acaii Tea, Pcs',
								product_uom: 'Pcs',
								soh: 0.0,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00053440',
								product_id: 13591,
								product_name: 'Styrofoam Isi Box Besar, Acaii Tea, Pcs',
								product_uom: 'Pcs',
								soh: 0.0,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00053441',
								product_id: 13592,
								product_name: 'Styrofoam isi Box Kecil, Acaii Tea, Pcs',
								product_uom: 'Pcs',
								soh: 0.0,
							},
						],
						product_category: 'Packaging Material',
					},
				],
			},
			{
				count_product_brand: 44,
				product_brand_id: 'Gaaram',
				products: [
					{
						count_product: 27,
						links: {
							next_page: '/pagination/159/Gaaram/Semi Finished Goods/2',
						},
						product: [
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00059189',
								product_id: 15430,
								product_name: 'Arabian Seasoning, Gaaram, gr',
								product_uom: 'Gr',
								soh: 500.0,
							},
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00057046',
								product_id: 15236,
								product_name: 'Ayam Batubara, Gaaram, Pax',
								product_uom: 'Pax',
								soh: 3.66,
							},
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00057045',
								product_id: 15235,
								product_name: 'Ayam Crispy, Gaaram, Pax',
								product_uom: 'Pax',
								soh: 97.065,
							},
							{
								category_complete_name:
									'Capitalize / Semi Finished Goods / Brand Partner',
								product_code: 'BRND00059518',
								product_id: 15439,
								product_name: 'Bumbu Asam Pedas, Gaaram, gr',
								product_uom: 'Gr',
								soh: -30.0,
							},
						],
						product_category: 'Semi Finished Goods',
					},
					{
						count_product: 1,
						product: [
							{
								category_complete_name:
									'Capitalize / Food Material / Brand Partner',
								product_code: 'BPFM00050368',
								product_id: 13435,
								product_name: 'Beras, Gaaram, 5 kg',
								product_uom: 'Pack 5kg',
								soh: 0.0,
							},
						],
						product_category: 'Food Material',
					},
					{
						count_product: 16,
						links: {
							next_page: '/pagination/159/Gaaram/Packaging Material/2',
						},
						product: [
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00050620',
								product_id: 13539,
								product_name: 'Aluminium Pouch 18 x 26, Gaaram, Pcs',
								product_uom: 'Pcs',
								soh: 160.0,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00051376',
								product_id: 13548,
								product_name: 'Aluminium pouch 8 x 11, Gaaram, Pcs',
								product_uom: 'Pcs',
								soh: 571.0,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00050362',
								product_id: 13525,
								product_name: 'Bowl TA Logo 17oz, Gaaram, 50 Pcs',
								product_uom: 'Pack 50pcs',
								soh: 0.0,
							},
							{
								category_complete_name:
									'Capitalize / Packaging Material / Brand Partner',
								product_code: 'BPPK00062991',
								product_id: 23134,
								product_name: 'Bowl TA Logo 24oz, Gaaram, Pcs',
								product_uom: 'Pcs',
								soh: 309.0,
							},
						],
						product_category: 'Packaging Material',
					},
				],
			},
		],
	},
];

export const settings = {
	dots: false,
	arrows: false,
	infinite: false,
	variableWidth: true,
	speed: 500,
	swipe: true,
	swipeToSlide: true,
};

export const statuses = [
	{ label: 'Aktif', value: true },
	{ label: 'Nonaktif', value: false },
];

export const times = Array(24 * 4)
	.fill(0)
	.map((_, i) => {
		return {
			label: ('0' + ~~(i / 4) + ':0' + 60 * ((i / 4) % 1)).replace(
				/\d(\d\d)/g,
				'$1',
			),
			value: ('0' + ~~(i / 4) + ':0' + 60 * ((i / 4) % 1)).replace(
				/\d(\d\d)/g,
				'$1',
			),
		};
	});
